<template>
  <div id="home" style="overflow-x: hidden">
    <!-- <el-tag type="success">标签二</el-tag> -->
    <el-form label-position="left" label-width="150px" class="demo-ruleForm">
      <div style="background-color: white; margin: 10px 20px">
        <div class="pos_container_panel">
          <el-row style="padding-top: 2rem">
            <el-col :span="12">
              <el-form-item label="客户名称：" style="margin-bottom: 0; margin-left: 1rem">
                  <el-input @click="showClientNamePop" readonly v-model="searchForm.client" placeholder="请选择" style="width: 58%; margin-left: 0px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="差规名称：" style="margin-bottom: 0; margin-left: 1rem">
                <el-select :disabled="disabled" style="width: 58%; margin-left: 0px" placeholder="请选择" v-model="travelRuleData.value" @change="travelRuleChange">
                  <el-option
                    v-for="item in travelRuleData.travelRulesNameInfo"
                    :key="item.key"
                    :label="item.value"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <hr class="hr_css"/>
          <el-row class="rowtop" style="background-color: aquamarine;">
            <el-col>
              <el-form-item label="协议价格类型：" style="margin-bottom: 0; margin-left: 1rem;">
                <el-checkbox  v-model="priceTypeInfo.priceTypeRadio">生效</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col>
              <el-transfer v-model="priceTypeInfo.priceTypeValue" :data="priceTypeInfo.priceTypeData"  :titles="['合规', '不合规']"></el-transfer>
            </el-col>
          </el-row>
          <hr class="hr_css"/>
          <el-row class="rowtop">
            <el-col>
              <div class="grid-content" style="float: right; margin-right: 120px">
                <el-button v-if="!disabled" type="warning" @click="saveForm">保存</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
    <!-- 子组件确认框  confirmMsg 提示内容-->
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <ClientList :customerDialogVisible = "clientListFlag" @setCustomerFlag = "setCustomerFlag" @customerInfo = "selectClient"></ClientList>
  </div>
</template>

<script>
import { getTripRules,getTripRule,addTripRule} from "@/api/tripruleData";
import { hideElement } from "@/utils/utils.js";
import ConfirmBoxs from "../../components/confirmBoxs.vue";
import ClientList from "@/components/ClientList.vue";
export default {
  name: "TravelRules",
  components: {
    ConfirmBoxs,
    ClientList,
  },
  data() {
    return {
      clientListFlag: false,
      disabled: true,
      searchForm: {
        client: "",
      },
      confirmIcon: "",
      confirmMsg: "", //提示消息内容
      confirmFlag: false, //提示框是否弹出
      priceTypeInfo:{
        priceTypeRadio: false,
        priceTypeData: [
        { key: 1, label: "CP"},
        { key: 2, label: "CHAINWIDE"},
        { key: 3, label: "AP"},
        { key: 4, label: "Others",}
        ],
        priceTypeValue:[],
      },
      travelRuleData: {
        travelRulesNameInfo: [],
        travelRulesInfo: {},
        value: "",
      },
      travelRuleJson:{
        HotelValidators:[],
      }
    };
  },
  mounted() {
    //判断来源 CRM、OBT跳转过来隐藏部分元素
    hideElement(this);
  },
  methods: {
    //========================================POS
    //选择客户
    selectClient(item) {
      this.hotelCustomerCode = item.customerCode;
      this.searchForm.client = item.customerName;
      this.searchRusult();
    },
    // 弹出客户姓名窗口方法
    showClientNamePop() {
      this.clientListFlag = true;
    },
    async searchRusult() {
      let customerParam = {
        params: {
          UserCode: this.hotelCustomerCode,
          LoginId: "admin",
        },
      };
      await getTripRules(customerParam)
        .then((res) => {
          this.travelRuleData.travelRulesNameInfo = [];
          this.travelRuleData.value = "";
          this.priceTypeInfo.priceTypeRadio = false;
          this.priceTypeInfo.priceTypeValue = [];
          if(res && res.totalItems >0){
            //this.travelRuleData.value = res.items[0].ruleName;
            for (const iterator of res.items) {
              this.travelRuleData.travelRulesNameInfo.push({
                key: iterator.id,
                value: iterator.ruleName,
              });
            }
          }
          this.disabled = false;
        })
        .catch();
    },
    async saveForm(){
      if(this.travelRuleData.value != ""){
        var priceTypeData = this.priceTypeInfo.priceTypeValue;
        this.travelRuleJson.HotelValidators = [];
        var AgreementPrices = [];
        //this.travelRuleJson.HotelValidators.IsDel = this.priceTypeInfo.priceTypeRadio? 0 : 1; //生效是0 不生效是1
        //this.travelRuleJson.HotelValidators.AgreementPrices = [];
        if(priceTypeData.length> 0){
          for (const iterator of priceTypeData) {
            AgreementPrices.push({
              "Op": "不合规",
					    "AgreementType": this.priceTypeInfo.priceTypeData[iterator-1].label,
            });
          }
        }
        this.travelRuleJson.HotelValidators.push({
          Type: "D",
          IsDel : this.priceTypeInfo.priceTypeRadio? 0 : 1,
          ValidatorType: "NegotiationPrice",
          AgreementPrices : AgreementPrices,
        });
        var json = JSON.stringify(this.travelRuleJson);
        this.travelRuleData.travelRulesInfo.LoginId = "admin";
        this.travelRuleData.travelRulesInfo.UserCode = this.hotelCustomerCode;
        this.travelRuleData.travelRulesInfo.OAOrgCode = "";
        this.travelRuleData.travelRulesInfo.OAEmpCategory = "";
        this.travelRuleData.travelRulesInfo.TripRuleDetailList = [], 
        this.travelRuleData.travelRulesInfo.RuleId = this.travelRuleData.travelRulesInfo.id,
        this.travelRuleData.travelRulesInfo.hotelTripRules = json;
        await addTripRule(this.travelRuleData.travelRulesInfo)
        .then((res) => {
          if(res.id > 0){
            this.confirmFlag = true;
            this.confirmMsg = "保存成功!";
            this.chosePriceType(res);
          }
        })
        .catch();
      }else{
        this.confirmFlag = true;
        this.confirmMsg = "请选择差规!";
      }
    },
    async travelRuleChange(value){
      await getTripRule(value.key)
        .then((res) => {
          this.travelRuleData.travelRulesInfo ={};
          this.chosePriceType(res);
          this.travelRuleData.travelRulesInfo = res;
        })
        .catch();
    },
    chosePriceType(res){
      var data = JSON.parse(res.hotelTripRules);
      var priceTypeKey = [];
      this.priceTypeInfo.priceTypeValue = [];
      this.priceTypeInfo.priceTypeRadio = false;
      if(data && data.HotelValidators.length > 0){
        this.priceTypeInfo.priceTypeRadio = data.HotelValidators[0].IsDel == 0? true: false;
        if(data.HotelValidators[0].AgreementPrices.length> 0){
          for (const iterator of data.HotelValidators[0].AgreementPrices) {
            switch(iterator.AgreementType){
              case "CP":
                priceTypeKey.push(1);
                break;
              case "AP":
                priceTypeKey.push(3);
                break;
              case "CHAINWIDE":
                priceTypeKey.push(2);
                break;
              case "Others":
                priceTypeKey.push(4);
                break;
            }
          }
        }
      }
      this.priceTypeInfo.priceTypeValue = priceTypeKey;
    },
    //子组件确认框
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
  },
};
</script>
<style scoped>
::v-deep .dialog-one .el-dialog__header,
::v-deep .dialog-one .el-tabs__active-bar {
  display: none;
}

::v-deep .dialog-one .el-dialog__body {
  padding: 0px;
}
::v-deep .el-input__inner {
  height: 2.7rem;
  line-height: 2.7rem;
}
.hr_css
{
  margin: 1rem -14rem 0rem;
  background-color: rgb(241 243 245);
  height: 0.2rem;
  border: none;
}
.rowtop {
  margin-top: 1.5rem;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  display: flex;
}
</style>
